import styled from '@emotion/styled';
import { Box, IconButton } from '@mui/material';

export const PlanButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 16px;
`;

export const SalonInfoWrapper = styled(Box)`
  padding: 12px 16px;
  padding-left: 0;
`;

export const SalonButtonsWrapper = styled(Box)`
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const StyledIconButton = styled(IconButton)`
  color: #1c1b1f;
  padding: 0;
`;

export const ResendPlanButtonWrapper = styled(Box)`
  button:not([data-id='kpi-formulas']) {
    padding: 9px 14px 9px 16px;
    border-radius: 8px;
    line-height: 16px;
    font-size: 15px;

    svg {
      padding-right: 6px;
    }
  }
`;
